import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './00_global/scripts/App';
import { developmentData } from './01_fundaments/utilities/localOverwrites';

const root = createRoot(document.getElementById('root'));

// development mode - set dummy backendData
if (import.meta.env.DEV) {
	window.backendData = JSON.parse(
		JSON.stringify(developmentData),
	);
}

// render the app
root.render(
	<BrowserRouter basename="/">
		<App />
	</BrowserRouter>,
);
